import {defineStore} from "pinia";
import {TicketType} from "@/utilities/enums/Enums";
import {useGlobalStore} from "@/stores/GlobalStore";

export const useGuestStore = defineStore('GuestStore', {
    state: () => {
        return {
            ticketGuid: null as string|null,
            ticketType: null as TicketType|null,
            token: null as string|null,
        }
    },
    actions: {
        showSuccess(text:string) {
            const globalStore = useGlobalStore();
            globalStore.success.show = true;
            globalStore.success.text = text === undefined ? "DEFAULT OK!" : text;
        },
    }
})
